module.exports = __webpack_public_path__ + "media/images/ui__backlinkArrow-07a9c5643e4ae556299f819ddd4c33e6.svg";